import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=3883bc24&lang=scss&scoped=true"
import "./header.vue?vue&type=style&index=1&id=3883bc24&scoped=true&lang=css"

import exportComponent from "D:\\Leo\\Frontend\\surveys\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3883bc24"]])

export default __exports__